(function() {
'use strict';

angular
    .module('dashboard')
    .directive('gravatarImage',
function(resourceService) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            email: '='
        },
        template: '<div class="avatar"><a class="edit-avatar" href="{{gravatarProfile}}" target="_blank">{{changeText}}</a></div>',
        link(scope, element) {
            scope.gravatarProfile = 'https://gravatar.com/profiles/no-such-user';
            scope.$watch('email', function(email) {
                if (email) {
                    scope.changeText = resourceService.get('CHANGE');
                    // eslint-disable-next-line new-cap
                    const hash = window.md5(email);
                    const image = new Image();
                    image.onload = function() {
                        element.append(image);
                    };
                    //fallback to mysterymen avatar
                    image.src = `https://www.gravatar.com/avatar/${hash}?d=mm`;
                    image.alt = 'user avatar';
                    scope.gravatarProfile = `https://www.gravatar.com/profiles/${hash}`;
                }
            });
        }
    };
});
})();
